import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../UserContext';
import './Layout.css';

const Layout = ({ children, className = '' }) => {
  const { isStudent, isTeacher, isAdmin } = useContext(UserContext);
  const location = useLocation();
  
  // Routes that should not show sidebar even for students/teachers
  const excludedRoutes = [
    '/sign-in',
    '/signup',
    '/forgot-password'
  ];
  
  // Check if current route should be excluded from sidebar
  const isExcludedRoute = excludedRoutes.includes(location.pathname);
  
  // Determine if this page should have sidebar spacing
  const hasSidebar = (isStudent || isTeacher) && !isExcludedRoute;
  
  return (
    <div className={`layout ${hasSidebar ? 'with-sidebar' : ''} ${className}`}>
      {children}
    </div>
  );
};

export default Layout;

